import lodash from 'lodash';
import { useCallback, useMemo } from 'react';
import { EventParams } from 'types/common';
import trackStore from '.';

export function useTrack() {
    const trackEvent = useCallback((eventParmas: EventParams) => {
        trackStore.trackEvent(eventParmas);
    }, []);

    /**
     * 有很多场景: 比如用户输入的埋点, 短时间输入是不需要频繁上报的, 是需要做防抖处理的, 这里统一提供一个防抖埋点的方法
     *
     * 这里使用useCallback会有eslint提示, 所以用的是useMemo实现:
     * React Hook useCallback received a function whose dependencies are unknown. Pass an inline function instead.
     */
    const debounceTrackEvent = useMemo(
        () =>
            lodash.debounce((eventParmas: EventParams) => {
                trackEvent(eventParmas);
            }, 500),
        [trackEvent]
    );

    return {
        debounceTrackEvent,
        trackEvent
    };
}
